<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <h1 class="max">Operações de Câmbio</h1>
        </v-flex>
        <v-layout row wrap class="transactions-filter" pt-4 px-3 style="justify-content: flex-end;">
          <v-flex xs12 md3 lg2 px-1>
            <v-switch
              append-icon="schedule"
              v-model="pendingFilter"
              label="Somente pendentes"
            ></v-switch>
          </v-flex>
          <v-flex xs12 md3 lg2 px-1>
            <v-select
              box
              label="Aprovação"
              append-icon="flaky"
              v-model="automaticFilter"
              clearable
              @click:clear="automaticFilter = null"
              :items="automaticFilterItems"
            ></v-select>
          </v-flex>
          <v-flex xs12 md3 lg2 class="align-contents-right">
            <v-btn class="filter-btn" color="#27DABC" depressed dark @click="reloadRecords()">
              Update
              <ion-icon name="funnel-outline"></ion-icon>
            </v-btn>
            <v-btn class="reload-filter-btn" flat icon color="white" @click="resetFilter()">
              <ion-icon name="reload-outline" size="large"></ion-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <div v-if="exchangesLoaded == 'not_loaded'">Carregando operações...</div>
          <div v-if="exchangesLoaded == 'error'">Algo errado. Não foi possível carregar as operações.</div>
          <div v-if="exchangesLoaded == 'not_authorized'">Não foi possível carregar as operações. Você não foi autorizado.</div>
          <div v-if="exchangesLoaded == 'empty'">Não existem operações de câmbio neste momento.</div>
          <transition name="fade">
            <exchange-list :is_admin="true" class="mt-3" :config="exchangesConfig" v-if="exchangesLoaded == 'ok'" @loadMoreRecords="loadExchanges"/>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import ExchangeList from "./ExchangeList"

export default {
  name: 'AdminExchangeList',
  components: { layout: LeftBarLayout, 'exchange-list': ExchangeList },
  data() {
    return {
      exchangesConfig: {
        title: 'Fechamentos de câmbio recentes',
        records: [],
        loading: false,
        lastPageLoaded: false
      },
      exchangesLoaded: 'not_loaded',
      automaticFilterItems: [{value: true, text: 'Automática'}, {value: false, text: 'Manual'}],
      automaticFilter: null,
      pendingFilter: null
    }
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()

    this.loadExchanges(null)
  },
  methods: {
    loadExchanges(last_id) {
      let successCallback = (response) => {
        this.exchangesConfig.loading = false

        if (response.body.data) {
          this.exchangesConfig.lastPageLoaded = response.body.data.length === 100
          
          this.exchangesConfig.records = this.exchangesConfig.records.concat(...response.body.data)

          if (this.exchangesConfig.records.length === 0) {
            this.exchangesLoaded = 'empty'
          } else {
            this.exchangesLoaded = 'ok'
          }
        } else {
          this.exchangesLoaded = 'error'
        }
      }

      let errorCallback = (response) => {
        this.exchangesConfig.loading = false

        if (response.status === 401) {
          this.exchangesLoaded = 'not_authorized'
        } else {
          this.exchangesLoaded = 'error'
        }
      }

      let params = { last_id: last_id, per_page: 100 }

      if (this.automaticFilter !== null) params.overnight = this.automaticFilter
      if (this.pendingFilter !== null) params.pending = this.pendingFilter

      this.exchangesConfig.loading = true
      let token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.admin_exchanges, { params: params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    resetFilter() {
      this.automaticFilter = null
      this.pendingFilter = false
    },
    reloadRecords() {
      this.exchangesConfig.records = []
      this.exchangesLoaded = 'not_loaded'
      this.loadExchanges(null)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/AdminExchangeList.vue